// Length of a FreeResponse answer as used by the counter and min/max checks.
// When `excludeSpaces` ("Karakterleri say" toggle) is on, whitespace is not
// counted — only visible characters count toward the limits.
export function answerLength(text, state) {
  const str = (text || "").toString();
  return state && state.excludeSpaces ? str.replace(/\s/g, "").length : str.length;
}
